import { Radio } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const OPTIONS = [
  { label: "Lịch sử nhận tiền", value: "history" },
  { label: "Lịch sử rút tiền", value: "request" },
];

const HistoryTab = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams?.get("tab") || "history";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleSelect = (value) => {
    setSearchParams({ tab: value });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Radio.Group
      size="middle"
      optionType="button"
      buttonStyle="solid"
      value={tab}
    >
      {OPTIONS?.map((item) => (
        <Radio.Button
          onClick={() => handleSelect(item?.value)}
          key={item.value}
          value={item.value}
        >
          {item?.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
export default HistoryTab;
